import React, { useRef, useState, useEffect, useContext } from 'react';
import { Button, Flex, Input, Text } from "@chakra-ui/react";
import { PayRentPropTypes } from "../PayRentPropTypes";
import { Form } from "react-final-form";
import { RenderBalanceDetailsModal, displayLoader, generateYearArray, renderAmountRadioGroup, renderDropDown, renderEnableAutoPayCheckbox, renderExpirationDropdown, renderStateDropdown } from "../Utils";
import { FormField } from "../../../components/form";
import { emailFormButtonProps, month, payRentMainContainerProps, statesList } from "../constants";
import { paymentWorldPayConfig1, paymentWorldPayConfig2 } from "../config";
import { formatBalance } from "../../../utils/constant";
import { localisable } from "../../../generic/localisable";
import { FacilityContext } from 'components/context';
import {
    createTenantCall,
    handleSurchargeOrDiscountCalculatorCall,
    worldPayPaymentCall
} from '../apis/paymentApis';
import { getIndivCookie } from 'utils/auth';

export const PayRentWorldPay = ({
    cardList,
    existingCardDetails,
    makePaymentHandler,
    logOffHandler,
    Balance,
    UnpaidAr,
    LastPaymentAmount,
    LastPaymentOn,
    shallShowEnableAutoPay,
    shallShowCVV = true,
    shallRenderCardIcons,
    IsAutoPaymentsEnabled,
    IsAutoPaymentsForced,
    category = 'option-01',
    tenantDetails,
    shallShowExpirationBlock,
    PreferredPaymentMethod,
    usingInMoveIn = false,
    moveInConfigs,
    IsOptingOutAutoPaymentRestricted
}: PayRentPropTypes.ICombinedPayRentProps) => {

    const formProps = useRef({});
    const { CCNumber, CCBillingAccountName, CCExpirationMonth, CCExpirationYear, CCBillingAddress, CCBillingZIP, CCCvv } = existingCardDetails || {};
    const [selectedPaymentMode, setSelectedPaymentMode] = useState('');
    const [amountType, setAmountType] = useState('balanceDue');
    const [isModalOpen, setModalOpen] = useState(false);
    const [loader, showLoader] = useState(false);
    const [totalAmount, setTotalAmount] = useState(Balance);
    const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
    const [payTypeDescription, setPayTypeDescription] = useState('');
    const [isPaymentButtonDisabled, setIsPaymentButtonDisabled] = useState(false);
    const cToken = getIndivCookie('cToken');
    const tempTenantToken = useRef<any>();
    const facilityContext = useContext<any>(FacilityContext);

    useEffect(() => {
        const selectedPayType = cardList.find(({ PayTypeID }: any) => PayTypeID == selectedPaymentMode);

        if (selectedPayType) {
            setPayTypeDescription(selectedPayType.PayTypeDescription);
        }
    }, [selectedPaymentMode]);

    const { FirstName, AddressLine1, AddressLine2, City, State, ZIP } = tenantDetails || {};

    const initialValuesOption1 = {
        cardHolderName: CCBillingAccountName || '',
        cardType: PreferredPaymentMethod || '',
        cardNumber: CCNumber || '',
        cvv: CCCvv || '',
        address: CCBillingAddress || '',
        zipCode: CCBillingZIP || '',
        expirationMonth: CCExpirationMonth || '',
        expirationYear: CCExpirationYear || '',
        amountToBeConsidered: '',
        amountTypeOpted: 'balanceDue',
        enableAutoPayments: IsAutoPaymentsEnabled || IsAutoPaymentsForced || false,
    };

    const initialValuesOption2 = {
        firstName: FirstName || '',
        cardType: PreferredPaymentMethod || '',
        cardNumber: CCNumber || '',
        cvv: CCCvv || '',
        expirationMonth: CCExpirationMonth || '',
        expirationYear: CCExpirationYear || '',
        addressLine1: AddressLine1 || '',
        addressLine2: AddressLine2 || '',
        zipCode: ZIP || '',
        city: City || '',
        state: State || '',
        amountToBeConsidered: '',
        amountTypeOpted: 'balanceDue',
        enableAutoPayments: IsAutoPaymentsEnabled || IsAutoPaymentsForced || false,
    };

    const handleSurchargeOrDiscountCalculator = async (amount: number, paymentMethodId: number) => {
        await handleSurchargeOrDiscountCalculatorCall(amount || 0, paymentMethodId, setIsPaymentButtonDisabled, setTotalPaymentAmount);
        setIsPaymentButtonDisabled(false);
        showLoader(false);
    };

    useEffect(() => {
        if (usingInMoveIn && cToken) {
            const findSurchargeForMoveInFlow = async () => {
                showLoader(true);
                await handleSurchargeOrDiscountCalculator(totalAmount, PreferredPaymentMethod || 0);
            }
            findSurchargeForMoveInFlow();
        }
    }, []);

    const onSubmit = async () => {
        if (!cToken) {
            const cTempToken = await createTenantCall(moveInConfigs);
            tempTenantToken.current = cTempToken;
        };
        if (category === 'option-01') {
            const {
                cardHolderName,
                cardNumber,
                cvv,
                enableAutoPayments,
                cardType,
                expirationMonth,
                expirationYear,
                address,
                zipCode
            } = (formProps.current as any).values || {};
            await worldPayPaymentCall(
                cardNumber,
                cardHolderName,
                expirationMonth,
                expirationYear,
                cvv,
                address,
                zipCode,
                enableAutoPayments,
                enableAutoPayments,
                // String(totalAmount),
                cardType,
                payTypeDescription,
                cToken || tempTenantToken.current,
                usingInMoveIn,
                String(totalPaymentAmount),
                moveInConfigs?.unitTypeId || '',
                facilityContext?.datoCmsFacilityDetails?.facilityName,
                moveInConfigs?.type,
                moveInConfigs?.moveInDate
            );
        } else if (category === 'option-02') {
            const {
                firstName,
                cardNumber,
                cvv,
                enableAutoPayments,
                cardType,
                expirationMonth,
                expirationYear,
                addressLine1,
                addressLine2,
                zipCode,
                city,
                state
            } = (formProps.current as any).values || {};
            await worldPayPaymentCall(
                cardNumber,
                firstName,
                expirationMonth,
                expirationYear,
                cvv,
                addressLine1.concat(addressLine2, city, state),
                zipCode,
                enableAutoPayments,
                enableAutoPayments,
                // String(totalAmount),
                cardType,
                payTypeDescription,
                cToken || tempTenantToken.current,
                usingInMoveIn,
                String(totalPaymentAmount),
                moveInConfigs?.unitTypeId || '',
                facilityContext?.datoCmsFacilityDetails?.facilityName,
                moveInConfigs?.type,
                moveInConfigs?.moveInDate
            );

        }

        // if (category === 'option-01') {

        //     const { cardHolderName, cardNumber, cvv, enableAutoPayments, cardType, expirationMonth, expirationYear,
        //         address, zipCode } = (formProps.current as any).values || {};

        //     const payload = {
        //         objPayment: {
        //             CCAccountNumber: cardNumber,
        //             CCAccountName: cardHolderName,
        //             CCExpirationMonth: expirationMonth,
        //             CCExpirationYear: expirationYear,
        //             CCAccountCVV2: cvv,
        //             CCAccountBillingAddress: address,
        //             CCAccountZIP: zipCode,
        //             SignUpForAutoPay: enableAutoPayments,
        //             PaymentAmount: totalAmount,
        //             PaymentAmountTotal: totalPaymentAmount,
        //             PayType: {
        //                 PayTypeID: cardType,
        //                 payTypeDescription: payTypeDescription,
        //             },
        //         },
        //         blnGenerateDocs: true,
        //     };
        //     makePaymentHandler(payload);

        // } else if (category === 'option-02') {

        //     const { firstName, cardNumber, cvv, enableAutoPayments, cardType, expirationMonth, expirationYear,
        //         addressLine1, addressLine2, zipCode, city, state, } = (formProps.current as any).values || {};

        //     const payload = {
        //         objPayment: {
        //             CCAccountNumber: cardNumber,
        //             CCAccountName: firstName,
        //             CCExpirationMonth: expirationMonth,
        //             CCExpirationYear: expirationYear,
        //             CCAccountCVV2: cvv,
        //             CCAccountBillingAddress: [addressLine1, addressLine2, city, state].join(', '),
        //             CCAccountZIP: zipCode,
        //             SignUpForAutoPay: enableAutoPayments,
        //             PaymentAmount: totalAmount,
        //             PaymentAmountTotal: totalPaymentAmount,
        //             PayType: {
        //                 PayTypeID: cardType,
        //                 payTypeDescription: payTypeDescription,
        //             },
        //         },
        //         blnGenerateDocs: true,
        //     };
        //     makePaymentHandler(payload);
        // }
    };

    const renderTotalAmountSection = () => {
        return <>
            {
                (totalPaymentAmount && totalPaymentAmount !== Number(totalAmount)) ? <Flex direction='column'>
                    <Text textStyle='subtitle' fontStyle='italic'>{(totalPaymentAmount > totalAmount) ? localisable.surcharge : localisable.discount}: {formatBalance(totalPaymentAmount - totalAmount)}</Text>
                    <Text textStyle='subtitle' fontStyle='italic'>{localisable.totalAmount}: {formatBalance(totalPaymentAmount)}</Text>
                </Flex> : null
            }
        </>
    };

    const renderButtonSection = () => {
        return (
            <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }}>
                <Button
                    {...emailFormButtonProps}
                    type='submit'
                    bg='button.blue'
                    minW={{ base: '100%', sm: '204px' }}
                    isDisabled={isPaymentButtonDisabled}
                >
                    <Text textStyle='buttonSmall' color='common.white' >{localisable.makePayment}</Text>
                </Button>
                {
                    cToken &&
                    <Button
                        {...emailFormButtonProps}
                        onClick={() => logOffHandler()}
                        bg='button.blue'
                        minW={{ base: '100%', sm: '204px' }}
                    >
                        <Text textStyle='buttonSmall' color='common.white' >{localisable.logOff}</Text>
                    </Button>
                }
            </Flex>
        )
    };

    const renderForm1 = (currentFormProps: any) => {

        const { amountProps, nameProps, addressProps, zipCodeProps, cardNumberProps, cvvProps, expirationMonthProps,
            expirationYearProps, enableAutopayProps } = paymentWorldPayConfig1() || {};

        return (
            <Flex direction='column' w='100%' padding={{ sm: '0px 96px' }} gap='24px'>
                <Text textStyle='h2' mb='8px'>{localisable.payment}</Text>
                <FormField
                    required
                    name="cardType"
                    label=''
                    {...currentFormProps}
                >
                    {renderDropDown(true, currentFormProps, cardList, shallRenderCardIcons = false, undefined,
                        setSelectedPaymentMode, 0, showLoader, handleSurchargeOrDiscountCalculator)}
                </FormField>
                <FormField
                    required
                    name="amountTypeOpted"
                    type='radio'
                    label=''
                    {...currentFormProps}
                >
                    {renderAmountRadioGroup(true, amountType, setAmountType, Balance, setTotalAmount, undefined, () => { }, setModalOpen,
                        currentFormProps.values.cardType, amountProps, currentFormProps, showLoader, PreferredPaymentMethod || 0, handleSurchargeOrDiscountCalculator)}
                </FormField>
                {loader ? displayLoader() : renderTotalAmountSection()}
                <FormField {...nameProps} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...addressProps} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...zipCodeProps} {...currentFormProps} >
                    <Input />
                </FormField>
                <Flex direction={{ base: 'column', sm: 'row' }} gap='16px'>
                    <FormField {...cardNumberProps} {...currentFormProps} >
                        <Input />
                    </FormField>
                    {shallShowCVV && <FormField {...cvvProps} {...currentFormProps} >
                        <Input />
                    </FormField>}
                </Flex>
                <Flex gap='16px' alignItems='flex-end'>
                    <FormField {...expirationMonthProps} {...currentFormProps}>
                        {renderExpirationDropdown(month, currentFormProps.values.expirationMonth)}
                    </FormField>
                    <FormField {...expirationYearProps} {...currentFormProps}>
                        {renderExpirationDropdown(generateYearArray(), currentFormProps.values.expirationYear)}
                    </FormField>
                </Flex>
                {
                    shallShowEnableAutoPay && <FormField {...enableAutopayProps} {...currentFormProps}>
                        {renderEnableAutoPayCheckbox(localisable.enableAutopay, IsAutoPaymentsForced, IsOptingOutAutoPaymentRestricted, currentFormProps.values.enableAutoPayments)}
                    </FormField>
                }
                {renderButtonSection()}
            </Flex >
        )
    }

    const renderForm2 = (currentFormProps: any) => {

        const { amountProps, nameProps, addressLine1Props, addressLine2Props, zipCodeProps, cardNumberProps, cvvProps,
            cityProps, stateProps, expirationMonthProps, expirationYearProps } = paymentWorldPayConfig2() || {};

        return (
            <Flex direction='column' w='100%' padding={{ sm: '0px 96px' }} gap='24px'>
                <Text textStyle='h2' mb='8px'>{localisable.payment}</Text>
                <FormField {...nameProps} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField
                    required
                    name="cardType"
                    label=''
                    {...currentFormProps}
                >
                    {renderDropDown(true, currentFormProps, cardList, shallRenderCardIcons = false, undefined,
                        setSelectedPaymentMode, 0, showLoader, handleSurchargeOrDiscountCalculator)}
                </FormField>
                <Flex direction={{ base: 'column', sm: 'row' }} gap='16px'>
                    <FormField {...cardNumberProps} {...currentFormProps} >
                        <Input />
                    </FormField>
                    {shallShowCVV && <FormField {...cvvProps} {...currentFormProps} >
                        <Input />
                    </FormField>}
                </Flex>
                {shallShowExpirationBlock && <Flex gap='16px' alignItems='flex-end'>
                    <FormField {...expirationMonthProps} {...currentFormProps}>
                        {renderExpirationDropdown(month, currentFormProps.values.expirationMonth)}
                    </FormField>
                    <FormField {...expirationYearProps} {...currentFormProps}>
                        {renderExpirationDropdown(generateYearArray(), currentFormProps.values.expirationYear)}
                    </FormField>
                </Flex>}
                <FormField
                    required
                    name="amountTypeOpted"
                    type='radio'
                    label=''
                    {...currentFormProps}
                >
                    {renderAmountRadioGroup(true, amountType, setAmountType, Balance, setTotalAmount, undefined, () => { }, setModalOpen,
                        currentFormProps.values.cardType, amountProps, currentFormProps, showLoader, PreferredPaymentMethod || 0, handleSurchargeOrDiscountCalculator)}
                </FormField>
                {loader ? displayLoader() : renderTotalAmountSection()}
                <FormField {...addressLine1Props} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...addressLine2Props} {...currentFormProps} >
                    <Input />
                </FormField>
                <Flex gap={{ base: '24px', sm: '32px' }} direction={{ base: 'column', sm: 'row' }} alignItems={{ sm: 'flex-start' }}>
                    <FormField {...cityProps} {...currentFormProps} >
                        <Input />
                    </FormField>
                    <Flex gap={{ base: '24px', sm: '32px' }}>
                        <FormField {...stateProps} {...currentFormProps}>
                            {renderStateDropdown(statesList, currentFormProps.values.state)}
                        </FormField>
                        <FormField {...zipCodeProps} {...currentFormProps} >
                            <Input />
                        </FormField>
                    </Flex>
                </Flex>
                {renderButtonSection()}
            </Flex >
        )
    }

    return (
        <Flex direction='column' {...payRentMainContainerProps} gap='24px'>
            <Form
                onSubmit={onSubmit}
                initialValues={category === 'option-01' ? initialValuesOption1 : initialValuesOption2}
                render={(currentFormProps) => {
                    const { handleSubmit, ...restFormProps } = currentFormProps;
                    formProps.current = restFormProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            {category === 'option-01' ? renderForm1(currentFormProps) : renderForm2(currentFormProps)}
                        </form>
                    )
                }}
            />
            {isModalOpen && <RenderBalanceDetailsModal
                Balance={Balance}
                UnpaidAr={UnpaidAr}
                LastPaymentAmount={LastPaymentAmount}
                LastPaymentOn={LastPaymentOn}
                isModalOpen={isModalOpen}
                setModalOpen={setModalOpen}
            />}
        </Flex>
    );
};